import { useRef } from 'react';

import Sidebar from 'components/Sidebar';
import HowPromobitWorks from 'components/Sidebar/HowPromobitWorks';

const CookiesSidebar = () => {
  const howPromobitWorksRef = useRef(null);

  return (
    <Sidebar
      className="mb-4 hidden md:block"
      refsToBeIgnoredBeforeFixing={[howPromobitWorksRef]}
    >
      <HowPromobitWorks ref={howPromobitWorksRef} />
    </Sidebar>
  );
};

export default CookiesSidebar;
